import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function PricingSection() {
  return <section id="offer" className="scroll-mt-20 bg-brand-alt px-4 py-20 md:py-28" data-id="element-112" data-mp="19jxdvgf8bdcx">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-113" data-mp="1ehytfrdg4ujn">
        <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-coral" data-id="element-114" data-mp="1egdyw1r4tbls">CENA PROMOCYJNA</p>
        <h2 className="mb-12 text-3xl font-black uppercase tracking-tight text-brand-navy md:text-4xl" data-id="element-115" data-mp="1nakcz9owj59j">
          🏆 Specjalna Oferta Startowa
        </h2>
        <div className="relative mx-auto max-w-xl rounded-[2rem] border-2 border-brand-coral bg-brand-alt p-8 pt-10 shadow-xl md:p-12" data-id="element-116" data-mp="1s8c6g8572zfu">
          <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-brand-coral px-5 py-2 text-[10px] font-extrabold tracking-[0.14em] text-white" data-id="element-117" data-mp="1x6vt6arm4f99">
            GOTOWI NA SIATKÓWKĘ
          </div>
          <div className="space-y-4 text-left" data-id="element-118" data-mp="7utm02ifx0qa">
            <PriceLine label="6 Kompletnych Tomów" price="249 zł" data-id="element-119" data-mp="7vmvvccp46cn" />
            <PriceLine label="5 Bonusów" price="199 zł" data-id="element-120" data-mp="1mi99x2rwowj9" />
            <div className="flex items-center justify-between border-t border-brand-dark pt-5 text-sm font-bold" data-id="element-121" data-mp="1hpg4sdsizm6n">
              <span data-id="element-122" data-mp="1cq3lg30v4x8t">WARTOŚĆ CAŁKOWITA:</span>
              <span className="text-brand-gray line-through" data-id="element-123" data-mp="1cosfpxnuxff2">448 zł</span>
            </div>
          </div>
          <div className="my-8 border-y border-brand-dark py-7" data-id="element-124" data-mp="17pxme1s9k8gp">
            <p className="text-xs font-extrabold tracking-[0.16em] text-brand-coral" data-id="element-125" data-mp="25e7t2u2zvke5">TYLKO DZIŚ</p>
            <p className="mt-2 font-display text-6xl font-black tracking-tight text-brand-navy md:text-7xl" data-id="element-126" data-mp="20hr1tr0i0pwu">
              69 <span className="text-2xl" data-id="element-127" data-mp="1vfjksn0tajnn">zł</span>
            </p>
          </div>
          <CTAButton href="https://gotowi-na-siatkowke.impultienda.ar/checkout" className="w-full py-5 text-base md:text-lg" data-id="element-128" data-mp="1rezn9icbte0z">
            CHCĘ PAKIET GOTOWI NA SIATKÓWKĘ
          </CTAButton>
          <p className="mt-6 text-xs font-semibold text-brand-gray" data-id="element-129" data-mp="g2p483ndww9q">
            Oferta ograniczona czasowo · Jednorazowa płatność · Dożywotni dostęp
          </p>
        </div>
      </Reveal>
    </section>;
}
function PriceLine({
  label,
  price
}: {
  label: string;
  price: string;
}) {
  return <div className="flex items-center justify-between border-b border-brand-dark pb-4 text-sm" data-id="element-130" data-mp="7jc4316is0gt">
      <span className="font-medium" data-id="element-131" data-mp="cgu2hxmwuxak">{label}</span>
      <span className="font-bold text-brand-navy line-through" data-id="element-132" data-mp="3uw4ksitdi2ib">{price}</span>
    </div>;
}